var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/types/user-health-goal-programs-for-admins.types.ts
var HealthGoalProgramsAdminStatus = /* @__PURE__ */ ((HealthGoalProgramsAdminStatus2) => {
  HealthGoalProgramsAdminStatus2["ACTIVE"] = "active";
  HealthGoalProgramsAdminStatus2["COMPLETED"] = "completed";
  HealthGoalProgramsAdminStatus2["QUIT"] = "quit";
  HealthGoalProgramsAdminStatus2["UPCOMING"] = "upcoming";
  return HealthGoalProgramsAdminStatus2;
})(HealthGoalProgramsAdminStatus || {});

// src/types/user-consents.types.ts
var UserConsentStatus = /* @__PURE__ */ ((UserConsentStatus2) => {
  UserConsentStatus2["REJECTED"] = "rejected";
  UserConsentStatus2["COMPLETED"] = "completed";
  return UserConsentStatus2;
})(UserConsentStatus || {});

// src/types/health-risk-assessments.types.ts
var HealthRiskAssessmentsStatus = /* @__PURE__ */ ((HealthRiskAssessmentsStatus2) => {
  HealthRiskAssessmentsStatus2["NOT_STARTED"] = "not_started";
  HealthRiskAssessmentsStatus2["IN_PROGRESS"] = "in_progress";
  HealthRiskAssessmentsStatus2["COMPLETED"] = "completed";
  return HealthRiskAssessmentsStatus2;
})(HealthRiskAssessmentsStatus || {});

// src/get-user-sessions.ts
import { leagueFetch } from "@leagueplatform/league-fetch";
var USER_SESSIONS_PATH = "v1/user-sessions";
var getUserSessions = (userId) => __async(void 0, null, function* () {
  const response = yield leagueFetch(
    `${USER_SESSIONS_PATH}?filter[userId]=${userId}`
  );
  if (!response.ok) {
    throw new Error(`getUserSessions error: ${response.status}`);
  }
  const responseJson = yield response.json();
  return responseJson;
});

// src/get-recommended-device.ts
import { leagueFetch as leagueFetch2 } from "@leagueplatform/league-fetch";
import { deserialise } from "kitsu-core";
var RECOMMENDED_DEVICE_PATH = "v1/apps";
var getRecommendedDevice = () => __async(void 0, null, function* () {
  const response = yield leagueFetch2(RECOMMENDED_DEVICE_PATH);
  if (!response.ok) {
    throw new Error(`getRecommendedDevice error: ${response.status}`);
  }
  const responseJson = yield response.json();
  return deserialise(responseJson);
});

// src/get-user-health-campaigns.ts
import { leagueFetch as leagueFetch3 } from "@leagueplatform/league-fetch";
var USER_HEALTH_CAMPAIGNS = "v1/user-health-campaigns";
var getUserHealthCampaigns = (userId) => __async(void 0, null, function* () {
  const response = yield leagueFetch3(
    `${USER_HEALTH_CAMPAIGNS}?filter[userId]=${userId}&filter[type]=reward&include=campaign`
  );
  if (!response.ok) {
    throw new Error(`getUserHealthCampaigns error: ${response.status}`);
  }
  const responseJson = yield response.json();
  return responseJson;
});

// src/get-user-consents.ts
import { leagueFetch as leagueFetch4 } from "@leagueplatform/league-fetch";
var USER_CONSENTS_PATH = "v1/user-consents";
var getUserConsents = (userId) => __async(void 0, null, function* () {
  const response = yield leagueFetch4(
    `${USER_CONSENTS_PATH}?filter[userId]=${userId}`
  );
  if (!response.ok) {
    throw new Error(`getUserConsents error: ${response.status}`);
  }
  const responseJson = yield response.json();
  return responseJson;
});

// src/get-health-risk-assessments.ts
import { leagueFetch as leagueFetch5 } from "@leagueplatform/league-fetch";
var HEALTH_RISK_ASSESSMENTS = "/v1/health-risk-assessments";
var getHealthRiskAssessments = (userId) => __async(void 0, null, function* () {
  const response = yield leagueFetch5(
    `${HEALTH_RISK_ASSESSMENTS}?filter[userId]=${userId}`
  );
  if (!response.ok) {
    throw new Error(`getHealthRiskAssessments error: ${response.status}`);
  }
  const responseJson = yield response.json();
  return responseJson;
});

// src/get-user-health-goal-programs-for-admin.ts
import { SocketAsFetch } from "@leagueplatform/socket-as-fetch";
var GET_USER_HEALTH_GOAL_PROGRAMS_FOR_ADMIN = "get_user_health_goal_programs_for_admin";
var getUserHealthGoalProgramsForAdmin = (userId) => __async(void 0, null, function* () {
  const info = {
    id: "user_health_goal_programs_for_admin",
    user_id: userId
  };
  const params = {
    message_type: GET_USER_HEALTH_GOAL_PROGRAMS_FOR_ADMIN,
    info
  };
  return SocketAsFetch.fetch(params);
});

// src/constants/customer-support.constants.ts
var GET_USER_SESSIONS = "get_user_sessions";
var GET_RECOMMENDED_DEVICE = "customer_apps";
var GET_USER_HEALTH_CAMPAIGNS = "get_user_health_campaigns";
var GET_USER_CONSENTS = "get_user_consents";
var GET_HEALTH_RISK_ASSESSMENTS = "get_health_risk_assessments";

// src/get-user-health-activity-for-admin.ts
import { SocketAsFetch as SocketAsFetch2 } from "@leagueplatform/socket-as-fetch";
import camelize from "camelize-ts";
var ADMIN_GET_USER_HEALTH_ACTIVITY = "admin_get_user_health_activity";
var getUserHealthActivityForAdmin = (userId, activityId) => __async(void 0, null, function* () {
  const info = {
    user_id: userId,
    id: activityId,
    version: 2
  };
  const params = {
    message_type: ADMIN_GET_USER_HEALTH_ACTIVITY,
    info
  };
  const response = yield SocketAsFetch2.fetch(params);
  return camelize(response.health_activity);
});

// src/mocks/get-user-health-activity-for-admin.mock.ts
var getUserHealthActivityForAdminMocks = {
  withList: {
    health_activity: {
      goal_id: "4MLaqWMYw84EbZpbb84Aj2",
      name: "Save Your Digital ID Card",
      icon_url: "https://images.ctfassets.net/ts22362wzosi/5VsH00IInTdcra6e2UXTOf/6a79a5903b66fd1e7f2910b8f4634a71/questionnaire.png",
      icon_description: "",
      id: "dyn-camp-KtPR3h8GGXoiVIuPqJqDRJEOesCFasLdumasI5anWKir64jCfsEdX5c",
      card_tagline: " Get Onboarded to Your Virtual Choice Plan",
      activity_points: 0,
      points_earned: 0,
      activity_tokens: 0,
      start_date: "0001-01-01T00:00:00Z",
      end_date: "0001-01-01T00:00:00Z",
      type: "healthJourney_toolboxActivity",
      status: "upcoming",
      suggested: false,
      can_expire: false,
      campaign_info: {
        campaign_id: "LqoBaCHHPIgNJ6GgqAPaD",
        name: " Get Onboarded to Your Virtual Choice Plan",
        start_date: "2023-11-30T16:39:56.207278Z",
        campaign_type: "opt-in",
        status: "active",
        description: "",
        end_date: void 0,
        quit_date: void 0,
        assigned: false,
        user_health_campaign_id: "dyn-camp-FysgxUTSr97pcjGVllCNIKGmEi0DA9PwpHQg0CMKACEuVWB2IdDuB5X"
      },
      front_of_the_line_activity: false,
      sort_order: 0,
      priority: "Low",
      detail_level: "Standard",
      activity_image: "https://images.ctfassets.net/ts22362wzosi/I0L9VkBbeQgiEHcsE0KqB/1a9b6db586639a844da8eec74c4926d4/Onboarding_Journey_-_Virtual_Choice_-_MYHMK__1_.png",
      required: false,
      tagline: " Get Onboarded to Your Virtual Choice Plan",
      description: "Save Your Digital ID Card",
      cta: {
        text: "",
        url: "",
        mark_as_complete: false,
        completion_method: { text: "", type: "" }
      },
      custom_fields: {
        opt_in_campaign_id: "LqoBaCHHPIgNJ6GgqAPaD",
        user_health_campaign_id: "dyn-camp-FysgxUTSr97pcjGVllCNIKGmEi0DA9PwpHQg0CMKACEuVWB2IdDuB5X"
      },
      category: "",
      activity_info: {
        name: "Save Your Digital ID Card",
        status: "active",
        reward: { availableValue: 0, earnedValue: 0, iconUrl: "", text: "" },
        pages: [
          {
            callToAction: {
              url: "",
              altText: "",
              text: ""
            },
            components: [
              {
                componentType: "header",
                componentAttributes: {
                  imageUrl: "https://images.ctfassets.net/ts22362wzosi/I0L9VkBbeQgiEHcsE0KqB/1a9b6db586639a844da8eec74c4926d4/Onboarding_Journey_-_Virtual_Choice_-_MYHMK__1_.png",
                  alt: "",
                  campaignName: " Get Onboarded to Your Virtual Choice Plan"
                }
              },
              {
                componentType: "rich-text",
                componentAttributes: {
                  richText: "<h2>View Your Benefits and Coverage</h2>Rest easy knowing you can easily access your benefits and health plan coverage all in one place."
                }
              },
              {
                componentType: "list",
                componentAttributes: {
                  list: [
                    "You can find your eligible benefits and coverage by navigating to the \u201Cbenefits\u201D section at the bottom of the app, or at the top of your web browser.",
                    "You can view your plan progress, previous claims, explanation of benefits, and see other benefits to help you live a healthier and happier life.",
                    "You can also access your Benefit Booklet and Plan Progress documents any time."
                  ]
                }
              }
            ]
          },
          {
            callToAction: {
              url: "",
              altText: "",
              text: ""
            },
            components: [
              {
                componentType: "rich-text",
                componentAttributes: {
                  richText: "<h2>Benefit Booklet</h2>Your benefit booklet has all the details about your plan benefits, like:"
                }
              },
              {
                componentType: "list",
                componentAttributes: {
                  list: [
                    "How to use your member ID card.",
                    "The importance of selecting a primary care provider.",
                    "How to get quality care and service.",
                    "Definitions of common health care insurance terms.",
                    "The Outline of Coverage and Member Agreement for your plan."
                  ]
                }
              }
            ]
          },
          {
            callToAction: {
              altText: "",
              text: "View Your Benefits",
              url: "/benefits/471dad3f2bd2b5837ccede93df321240"
            },
            components: [
              {
                componentType: "rich-text",
                componentAttributes: {
                  richText: "<h2>Plan Progress</h2>Your plan progress contains a snapshot of your plan benefits for easy reference, including: "
                }
              },
              {
                componentType: "list",
                componentAttributes: {
                  list: [
                    "Deductibles and when they are applied.",
                    "Out-of-pocket limits.",
                    "Copays for office visits and medications.",
                    "Commonly covered services.",
                    "Excluded services."
                  ]
                }
              }
            ]
          }
        ],
        category: "",
        warning: void 0,
        removable: false
      }
    }
  },
  noRichTextOnFirstPage: {
    health_activity: {
      goal_id: "4MLaqWMYw84EbZpbb84Aj2",
      name: "Save Your Digital ID Card",
      icon_url: "https://images.ctfassets.net/ts22362wzosi/5VsH00IInTdcra6e2UXTOf/6a79a5903b66fd1e7f2910b8f4634a71/questionnaire.png",
      icon_description: "",
      id: "dyn-camp-KtPR3h8GGXoiVIuPqJqDRJEOesCFasLdumasI5anWKir64jCfsEdX5c",
      card_tagline: " Get Onboarded to Your Virtual Choice Plan",
      activity_points: 0,
      points_earned: 0,
      activity_tokens: 0,
      start_date: "0001-01-01T00:00:00Z",
      end_date: "0001-01-01T00:00:00Z",
      type: "healthJourney_toolboxActivity",
      status: "upcoming",
      suggested: false,
      can_expire: false,
      campaign_info: {
        campaign_id: "LqoBaCHHPIgNJ6GgqAPaD",
        name: " Get Onboarded to Your Virtual Choice Plan",
        start_date: "2023-11-30T16:39:56.207278Z",
        campaign_type: "opt-in",
        status: "active",
        description: "",
        end_date: void 0,
        quit_date: void 0,
        assigned: false,
        user_health_campaign_id: "dyn-camp-FysgxUTSr97pcjGVllCNIKGmEi0DA9PwpHQg0CMKACEuVWB2IdDuB5X"
      },
      front_of_the_line_activity: false,
      sort_order: 0,
      priority: "Low",
      detail_level: "Standard",
      activity_image: "https://images.ctfassets.net/ts22362wzosi/I0L9VkBbeQgiEHcsE0KqB/1a9b6db586639a844da8eec74c4926d4/Onboarding_Journey_-_Virtual_Choice_-_MYHMK__1_.png",
      required: false,
      tagline: " Get Onboarded to Your Virtual Choice Plan",
      description: "Save Your Digital ID Card",
      cta: {
        text: "",
        url: "",
        mark_as_complete: false,
        completion_method: { text: "", type: "" }
      },
      custom_fields: {
        opt_in_campaign_id: "LqoBaCHHPIgNJ6GgqAPaD",
        user_health_campaign_id: "dyn-camp-FysgxUTSr97pcjGVllCNIKGmEi0DA9PwpHQg0CMKACEuVWB2IdDuB5X"
      },
      category: "",
      activity_info: {
        name: "Save Your Digital ID Card",
        status: "active",
        reward: { availableValue: 0, earnedValue: 0, iconUrl: "", text: "" },
        pages: [
          {
            callToAction: {
              text: "View Card",
              url: "/benefits/471dad3f2bd2b5837ccede93df321240",
              altText: ""
            },
            components: [
              {
                componentType: "rewards-header",
                componentAttributes: {
                  alt: "",
                  caption: "",
                  imageUrl: "https://images.ctfassets.net/ts22362wzosi/I0L9VkBbeQgiEHcsE0KqB/1a9b6db586639a844da8eec74c4926d4/Onboarding_Journey_-_Virtual_Choice_-_MYHMK__1_.png"
                }
              }
            ],
            branchingLogic: void 0
          },
          {
            callToAction: {
              text: "View Card",
              url: "/benefits/471dad3f2bd2b5837ccede93df321240",
              altText: ""
            },
            components: [
              {
                componentType: "rewards-header",
                componentAttributes: {
                  alt: "",
                  caption: "",
                  imageUrl: "https://images.ctfassets.net/ts22362wzosi/I0L9VkBbeQgiEHcsE0KqB/1a9b6db586639a844da8eec74c4926d4/Onboarding_Journey_-_Virtual_Choice_-_MYHMK__1_.png"
                }
              },
              {
                componentType: "rich-text",
                componentAttributes: {
                  richtext: "<h2>Save Your Digital ID Card</h2>Enjoy the convenience, security, and flexibility of having your insurance card saved to your smartphone.<br><br>Click below to download your digital insurance card.\n"
                }
              }
            ],
            branchingLogic: void 0
          }
        ],
        category: "",
        warning: void 0,
        removable: false
      }
    }
  }
};

// src/get-user-challenges.ts
import { leagueFetch as leagueFetch6 } from "@leagueplatform/league-fetch";
import { deserialise as deserialise2 } from "kitsu-core";
var GET_USER_CHALLENGES = "v1/user-challenges";
var getUserChallenges = (userId) => __async(void 0, null, function* () {
  const response = yield leagueFetch6(
    `${GET_USER_CHALLENGES}?filter[userId]=${userId}&include=challenge`
  );
  if (!response.ok) {
    throw new Error(`getUserChallenges error: ${response.status}`);
  }
  const responseJson = yield response.json();
  return deserialise2(responseJson);
});

// src/get-user-challenge.ts
import { leagueFetch as leagueFetch7 } from "@leagueplatform/league-fetch";
import { deserialise as deserialise3 } from "kitsu-core";
var getUserChallenge = (userId, challengeId) => __async(void 0, null, function* () {
  const response = yield leagueFetch7(
    `${GET_USER_CHALLENGES}/${challengeId}?filter[userId]=${userId}`
  );
  if (!response.ok) {
    throw new Error(`getUserChallenge error: ${response.status}`);
  }
  const responseJson = yield response.json();
  return deserialise3(responseJson);
});

// src/test-api.ts
function testApiCall() {
  return __async(this, null, function* () {
    return {
      some_wallet_key: "some wallet data!"
    };
  });
}
export {
  ADMIN_GET_USER_HEALTH_ACTIVITY,
  GET_HEALTH_RISK_ASSESSMENTS,
  GET_RECOMMENDED_DEVICE,
  GET_USER_CHALLENGES,
  GET_USER_CONSENTS,
  GET_USER_HEALTH_CAMPAIGNS,
  GET_USER_HEALTH_GOAL_PROGRAMS_FOR_ADMIN,
  GET_USER_SESSIONS,
  HealthGoalProgramsAdminStatus,
  HealthRiskAssessmentsStatus,
  RECOMMENDED_DEVICE_PATH,
  USER_SESSIONS_PATH,
  UserConsentStatus,
  getHealthRiskAssessments,
  getRecommendedDevice,
  getUserChallenge,
  getUserChallenges,
  getUserConsents,
  getUserHealthActivityForAdmin,
  getUserHealthActivityForAdminMocks,
  getUserHealthCampaigns,
  getUserHealthGoalProgramsForAdmin,
  getUserSessions,
  testApiCall
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/cse-customer-support-api'] = window.leagueSDKsPresent['@leagueplatform/cse-customer-support-api'] || [];
    window.leagueSDKsPresent['@leagueplatform/cse-customer-support-api'].push('0.2.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/cse-customer-support-api'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/cse-customer-support-api module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map